import { render, staticRenderFns } from "./ProcedurePopup.vue?vue&type=template&id=0a852238&scoped=true&"
import script from "./ProcedurePopup.vue?vue&type=script&lang=js&"
export * from "./ProcedurePopup.vue?vue&type=script&lang=js&"
import style0 from "./ProcedurePopup.vue?vue&type=style&index=0&id=0a852238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a852238",
  null
  
)

export default component.exports